import { NgStyle } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { TransportforetagSearchResultDTO } from "~app/common/models/kontakter/TransportforetagSearchResultDTO";

@Component({
    selector: "rask-transportforetag-list",
    templateUrl: "./transportforetag-list.component.html",
    styleUrls: ["./transportforetag-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        NgStyle,
        RouterLink
    ]
})
export class TransportforetagListComponent {

    @Input() transportforetag: TransportforetagSearchResultDTO[];
}
